import React, { useEffect, useState } from 'react';

// Animated concentric ring: dual arc (background + progress) with gradient.
const RingProgress = ({ pct = 0, size = 130, stroke = 12, label = 'Filled' }) => {
  const [animPct, setAnimPct] = useState(0);
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;

  useEffect(() => {
    const target = Math.max(0, Math.min(100, Number(pct) || 0));
    const start = performance.now();
    const from = animPct;
    const dur = 900;
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setAnimPct(from + (target - from) * eased);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pct]);

  const dashOffset = circ * (1 - animPct / 100);
  const gradId = 'ringGrad-' + Math.random().toString(36).slice(2, 8);

  return (
    <div className="ring-progress" style={{ width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%"  stopColor="#00ff9d" />
            <stop offset="50%" stopColor="#00e5ff" />
            <stop offset="100%" stopColor="#7fff00" />
          </linearGradient>
          <filter id={gradId + '-glow'}><feGaussianBlur stdDeviation="2" /></filter>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none"
          stroke="rgba(0, 255, 157, 0.08)" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none"
          stroke={`url(#${gradId})`} strokeWidth={stroke}
          strokeDasharray={circ} strokeDashoffset={dashOffset}
          strokeLinecap="round"
          filter={`url(#${gradId}-glow)`} opacity="0.5" />
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none"
          stroke={`url(#${gradId})`} strokeWidth={stroke}
          strokeDasharray={circ} strokeDashoffset={dashOffset}
          strokeLinecap="round" />
      </svg>
      <div className="ring-progress-center">
        <div className="ring-progress-pct">{animPct.toFixed(1)}%</div>
        <div className="ring-progress-label">{label}</div>
      </div>
    </div>
  );
};

export default RingProgress;
